module.exports = __webpack_public_path__ + "img/img_Colleges7.0bd06e13.png";